import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ClassificationPanelViewModel} from './classification-panel/classification-panel.component';

@Component({
    selector: 'af-classification-group-panel',
    standalone: false,
    templateUrl: './classification-group-panel.component.html',
    styleUrl: './classification-group-panel.component.scss',
})
export class ClassificationGroupPanelComponent {
    @Input() classificationGroupPanelData: ClassificationGroupPanelViewModel[];
    @Output() clickListener = new EventEmitter<ClassificationPanelViewModel>();
}

export interface ClassificationGroupPanelViewModel {
    groupCode: string;
    groupName: string;
    items: ClassificationPanelViewModel[];
}
